import { render } from "./Datos.vue?vue&type=template&id=af3f228c&scoped=true"
import script from "./Datos.vue?vue&type=script&lang=js"
export * from "./Datos.vue?vue&type=script&lang=js"

import "./Datos.vue?vue&type=style&index=0&id=af3f228c&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af3f228c"]])

export default __exports__